import { computed, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex'
export default function () {
  const store = useStore()
  /**登录用户信息 */
  const userInfo = computed(() => store.state.app.account.userInfo || {})
  /**当前登录人单位 */
  const unitName = computed(() => userInfo.value.unitName)
  /**当前登录人Id */
  const unitId = computed(() => userInfo.value.unitId)
  /**当前登录人行政区划 */
  const currentAreaCode = computed(() => (userInfo.value.areaCode == '0' ? '000000' : userInfo.value.areaCode))
  /**角色 */
  const roleAlias = computed(() => (userInfo.value.roleAlias ? userInfo.value.roleAlias.split(',') : ''))
  /**角色 */
  const roleIds = computed(() => (userInfo.value.roleId ? userInfo.value.roleId.split(',') : []))
  /**区域级别 */
  const regionLevels = computed(() =>
    userInfo.value.regionLevels == 'null' || userInfo.value.regionLevels == null ? '1' : parseInt(userInfo.value.regionLevels).toString()
  )
  const areaCode = computed(() => userInfo.value.areaCode)

  /**当前登录人的区划信息 */
  const currentRegion = async () => {
    return await store.dispatch('biz/admin/currentRegion/getInfo', { code: currentAreaCode.value })
  }

  const areaParentCode = computed({
    get() {
      if (!userInfo.value.areaCode) {
        return ''
      }
      let cityCode = parseInt(userInfo.value.areaCode.split('').reverse().join('')).toString().split('').reverse().join('')

      if (userInfo.value.areaCode == '000000') return '0'
      let parentCode = ((cityCode.length > 2 ? cityCode.substring(0, cityCode.length - 2) : '00') + '000000').substring(0, 6)

      return parentCode
    }
  })
  const currentUnitInfo = async () => {
    return await store.dispatch('biz/penalize/unitInfo/getCurrentOrgData')
  }

  /**指定区划的的区划信息 */
  const customCurrentRegion = async areaCode => {
    return await store.dispatch('biz/admin/currentRegion/getInfo', { code: areaCode })
  }
  const stop = watch(unitId, (val, old) => {
    if (val != old) {
      store.commit('biz/penalize/unitInfo/setOrgData', {})
    }
  })
  onUnmounted(() => stop())
  return {
    userInfo,
    unitName,
    unitId,
    regionLevels,
    currentUnitInfo,
    roleIds,
    areaCode,
    areaParentCode,
    roleAlias,
    currentRegion,
    customCurrentRegion
  }
}
